import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import generateGuid from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";

const SelectInput = (props) => {
	const hasValue = !!props.value;
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const hasLabel = !!props.label;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const defaultItem = props.defaultItem ? props.defaultItem : "Kies een optie";
	const value = props.value ? props.value : "";
	const valueIndex = props.items.map(item => item.value).indexOf(props.value);
	const sizeClassName = props.size ? "o-col-" + props.size : (props.small ? "" : "o-col-12");
	const label = hasLabel ? props.label + (props.optional ? " (Optioneel)" : "") : null;
	const info = props.tooltip ? <Tooltip isInput text={props.tooltip} tooltipType={tooltiptype} /> : null;
	const validation = props.validationMessage ? <ValidationMessage validationMessage={props.validationMessage} type={validationMessageType} /> : null;
	const id = generateGuid();

	const small = props.small;
	const style = props.small ? { margin: "4px", padding: "2px 30px 2px 2px", minHeight: "2em", color: "black", fontWeight: "normal", width: "auto" } : null;

	const inputClassName = classnames({
		"c-input__field": true
	});
	const labelClassName = classnames({
		"c-input__label": true,
		"has-value": true
	});

	const containerClassName = props.small ? null : classnames({
		"c-input": true,
		"c-input--dropdown": true,
		"has-value": true,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
		"disabled": props.disabled
	});

	const select = (<select
		id={id}
		value={value}
		onChange={props.onChange}
		disabled={props.disabled}
		name={props.name}
		className={inputClassName}
		style={style} >
		<option value="">{defaultItem}</option>
		{
			props.items.map((item) => {
				return (
					<option key={item.value} value={item.value}>
						{item.label}
					</option>);
			})
		}
	</select>);

	return (small ? select :
		<div className={sizeClassName}>
			<div className={containerClassName}>
				{select}
				{hasLabel ? <label className={labelClassName} htmlFor={id}>{label}</label> : null}
				{info}
			</div>
			{validation}
		</div>);
};

SelectInput.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]),
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	size: PropTypes.number,
	optional: PropTypes.bool,
	defaultItem: PropTypes.string,
	items: PropTypes.array,
	small: PropTypes.bool
};

export default SelectInput;
